import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { MasterMakeService } from '../../share/services/master-make/master-make.service';
import { MasterModelService } from '../../share/services/master-model/master-model.service';
import { faCircleCheck, faEdit, faInfoCircle, faTrash, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AcceptRejectConfirmationModalComponent } from 'src/app/admin/company/accept-reject-confirmation-modal/accept-reject-confirmation-modal.component';

@Component({
    selector: 'app-pending-tyre-pattern',
    templateUrl: './pending-tyre-pattern.component.html',
    styleUrls: ['./pending-tyre-pattern.component.scss'],
    standalone: false
})
export class PendingTyrePatternComponent implements OnInit {
  customSearchFn = () => true;
  addTyreModelForm: FormGroup;
  modelList: any[] = [];
  showEditMakePopup: boolean = false;
  descriptionPopup: boolean = false;
  makeList: any[] = [];
  tyreSize: {search: '', page: number, list: any[]}[] = [{search: '', page: 0, list: []}];
  pageNumber: number = 0;
  endOfResults: boolean = false;
  currentPageNumber: number = 0;
  tyreMakeSearch: any;
  tyreMakeObj: any = {};
  errorMessage: any;
  tyreSizeObj: any = { page: 0 };
  tyreModelObj: any = { page: 0 };
  filters: any = {};
  isToster: boolean = false;
  message: any;
  isLoading: boolean = false;
  loader: boolean = false;
  popupType: string = "Add";
  modelId!: string;
  descriptionText: string = '';

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterMakeService: MasterMakeService,
    private readonly masterModelService: MasterModelService,
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: NgbModal
  ) {
    this.addTyreModelForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      tyreMake: [null, [Validators.required]],
      description: [''],
      tyreDetails: this.formBuilder.array([this.createTyreDetailsGroup()]),
    });
  }

  ngOnInit(): void {
    this.initData();
  }

  createTyreDetailsGroup(): FormGroup {
    return this.formBuilder.group({
      tyreSize: [null],
      speed: [''],
      loadIndex: [''],
    });
  }

  get tyreDetails(): FormArray {
    return this.addTyreModelForm.get('tyreDetails') as FormArray;
  }

  addMoreTyreDetails() {
    const newIndex = this.tyreDetails.length;
    this.tyreSize.push({search: '', page: 0, list: []});
    this.tyreSizeObj.page = 0;
    this.tyreSizeObj.searchTerm = '';
    this.getTyreSize(newIndex);
    this.tyreDetails.push(this.createTyreDetailsGroup());
    this.cdr.detectChanges();
  }

  removeTyreDetails(index: number) {
    this.tyreDetails.removeAt(index);
    this.tyreSize.splice(index, 1);
  }

  getTyreMake() {
    this.loader = true;
    this.tyreMakeObj.page = this.pageNumber;
    this.masterMakeService
      .getTyreMakeDetails(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm)
      .subscribe({
      next: (res: any) => {
        this.loader = false;
        if (this.tyreMakeObj.page == 0) {
          this.makeList = [];
          this.makeList = res.data || [];
        } else {
          this.makeList = this.makeList.concat(res.data || []);
        }
        if (res.data.length === 0) {
          this.endOfResults = true;
        }
      },
      error: (error) => {
          this.errorMessage = error?.error?.error?.message;
          this.loader = false;
        }
    });
  }

  getTyreSize(index: number = 0) {
    this.masterMakeService.getTyreDetails(this.tyreSizeObj).subscribe((res: any) => {
      if (this.tyreSizeObj.page == 0) {
        this.tyreSize[index].list = res.data || [];
      } else {
        this.tyreSize[index].list = (this.tyreSize[index].list || []).concat(res.data || []);
      }
    });
  }

  getVehicleModel() {
    this.loader = true;
    this.masterModelService.getPendingTyreModelDetails(this.tyreModelObj, this.filters)
      .subscribe({
      next: (res: any) => {
        this.loader = false;
        if (this.tyreModelObj.page == 0) {
          this.modelList = [];
          this.modelList = res.data || [];
        } else {
          this.modelList = this.modelList.concat(res.data || []);
        }
      },
      error: (error) => {
          this.errorMessage = error?.error?.error?.message;
          this.loader = false;
        }
    });
  }

  FilterList(make: string, size: string, name: string) {
    this.pageNumber = 0;
    this.tyreModelObj.page = this.pageNumber;
    this.modelList = [];
    this.filters.tyreMake = make || '';
    this.filters.tyreSize = size || '';
    this.filters.name = name || '';
    this.getVehicleModel();
  }


  saveVehicleModel() {
    this.isLoading = true;

    if (this.popupType === 'Update') {
      this.masterModelService.updateTyrePattern(
        this.addTyreModelForm.value,
        this.modelId
      ).subscribe({
      next: (res: any) => {
          this.isLoading = false;
          this.getVehicleModel();
          this.closePopup();
          this.isToster = true;
          this.message = res.message;
        },
      error: (error) => {
          this.errorMessage = error?.error?.error?.message;
          this.isLoading = false;
        }
    });
    } else {
      this.masterModelService.saveTyreModelDetails(
        this.addTyreModelForm.value
      ).subscribe({
        next: (res: any) => {
          this.isLoading = false;
          this.getVehicleModel();
          this.closePopup();
          this.isToster = true;
          this.message = res.message;
        },
        error: (error) => {
          this.errorMessage = error?.error?.error?.message;
          this.isLoading = false;
        }
      });
    }
  }


  tyreModelFormPopup() {
    this.showEditMakePopup = true;
  }

  descriptionOverlay(index: number) {
    const selectedModel = this.modelList[index];
    if (selectedModel?.description && selectedModel.description.trim().length > 0) {
      this.descriptionPopup = true;
      this.message = selectedModel.description;
    } else {
      this.descriptionPopup = false;
    }
  }

  initData() {
    this.tyreMakeObj.searchTerm = "";
    this.tyreSizeObj.searchTerm = "";
    this.getVehicleModel();
    this.getTyreMake();
    this.tyreSize = [{search: '', page: 0, list: []}];
    this.getTyreSize(0);
  }

  closePopup() {
    this.initData();
    this.getVehicleModel();
    this.showEditMakePopup = false;
    this.addTyreModelForm.reset();
    this.tyreDetails.clear();
    this.tyreSize = [{search: '', page: 0, list: []}];
    this.tyreDetails.push(this.createTyreDetailsGroup());
    this.popupType = 'Add';
  }

  closeOverlay() {
    this.descriptionPopup = false;
  }



  onTyreMakeInputChange(event: any) {
    this.makeList = [];
    this.tyreMakeObj.page = 0;
    this.tyreMakeSearch = event?.term ? event.term : '';
    this.tyreMakeObj.searchTerm = this.tyreMakeSearch;
    this.getTyreMake();
  }





  onTyreSizeInputChange(event: any, index: number) {
    if (!this.tyreSize[index]) {
      this.tyreSize[index] = { search: '', page: 0, list: [] };
    }
    this.tyreSize[index].list = [];
    this.tyreSize[index].page = 0;
    let tyreSizeSearch = event?.term ? event.term : '';
    this.tyreSize[index].search = tyreSizeSearch;
    this.tyreSizeObj.page = 0;
    this.tyreSizeObj.searchTerm = tyreSizeSearch;
    this.getTyreSize(index);
  }


  onScroll() {
    if (this.endOfResults) {
      return;
    } else {
      this.pageNumber++;
      this.tyreMakeObj.page = this.pageNumber;
      this.getTyreMake();
    }
  }

  scroll(index: number) {
    if (this.tyreSize[index].list.length % 20 === 0) {
      this.tyreSize[index].page++;
      this.tyreSizeObj.page = this.tyreSize[index].page;
      this.tyreSizeObj.searchTerm = this.tyreSize[index].search;
      this.getTyreSize(index);
    }
  }

  listScroll() {
    if (this.modelList.length % 20 === 0) {
      this.tyreModelObj.page++;
      this.getVehicleModel();
    }
  }

  closeToster(event: any) {
    this.isToster = false;
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 3) {
      inputElement.value = inputElement.value.slice(0, 3);
      const tyreDetailsFormArray = this.addTyreModelForm.get('tyreDetails') as FormArray;
      const lastGroup = tyreDetailsFormArray.at(-1) as FormGroup;
      lastGroup.controls['loadIndex'].setValue(inputElement.value);
    }
  }

  editTyreModel(type: string, model?: any): void {
    this.errorMessage = '';
    if (type === 'edit' && model) {
      this.popupType = 'Update';
      this.addTyreModelForm.patchValue({
        name: model.name,
        tyreMake: model.tyreMake,
        description: model.description,
      });
      this.tyreDetails.clear();
      this.tyreSize = [];
      model.tyreDetails.forEach((detail: any, index: number) => {
        this.tyreSize.push({search: '', page: 0, list: []});
        this.getTyreSize(index);
        const detailGroup = this.createTyreDetailsGroup();
        detailGroup.patchValue(detail);
        this.tyreDetails.push(detailGroup);
      });
      this.modelId = model._id;
      this.showEditMakePopup = true;
    } else {
      this.popupType = 'Add';
      this.tyreSize = [{search: '', page: 0, list: []}];
      this.getTyreSize(0);
    }
    this.showEditMakePopup = true;
  }

  activateTyreBrand(tyreDetails: any, isActive: any) {
    let dialogRef = this.modalService.open(AcceptRejectConfirmationModalComponent, {
      backdrop: 'static',
      size: 'md',
      keyboard: false,
      centered: true,
    });
    dialogRef.componentInstance.tyreDetails = tyreDetails;
    dialogRef.componentInstance.companyActivated = isActive;
    dialogRef.result.then(
      (result) => {
        if (result?.status) {
          const id = tyreDetails._id;
          this.masterModelService.activePendingTyreModel({}, id).subscribe((res: any) => {
            if (res['success']) {
              this.getVehicleModel();
            }
            this.isToster = true;
            this.message = res.message;
          });
        }
      },
      (reason) => {
      }
    );
  }

  protected readonly faInfo = faInfoCircle;
  protected readonly faEdit = faEdit;
  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;
  protected readonly faCircleCheck = faCircleCheck;
  protected readonly faSearch = faSearch;
}
